// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.y2uxss0 {
  display: grid;
  appearance: none;
  margin: 0;
  font: inherit;
  color: white;
  border: 1px solid;
  place-content: center;
  border-radius: var(--_18w76bwa);
  border-width: var(--_18w76bwa);
  margin-top: var(--_18w76bwb);
  border-color: var(--_18w76bw34);
  background-color: var(--_18w76bw24);
}
.y2uxss0:before {
  content: url(
          "data:image/svg+xml,<svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'><path d='M8.15147 20.5971L0.351472 12.7971C-0.117137 12.3285 -0.117137 11.5687 0.351472 11.1L2.04849 9.40294C2.5171 8.93428 3.27694 8.93428 3.74555 9.40294L9 14.6573L20.2545 3.40294C20.7231 2.93433 21.4829 2.93433 21.9515 3.40294L23.6485 5.1C24.1171 5.56861 24.1171 6.32841 23.6485 6.79706L9.84854 20.5971C9.37988 21.0657 8.62008 21.0657 8.15147 20.5971Z' fill='white'/></svg>"
        );
  display: none;
  width: var(--_18w76bwe);
  height: var(--_18w76bwe);
  border-radius: 0;
  margin-bottom: var(--_18w76bwb);
  transition: 100ms transform ease-in-out;
}
.y2uxss0:focus:not(:checked) {
  border-color: var(--_18w76bw2e);
}
.y2uxss0:checked {
  background-color: var(--_18w76bw30);
  border-color: var(--_18w76bw30);
}
.y2uxss0:checked:before {
  display: block;
}
.y2uxss2:checked {
  background-color: inherit;
  border-color: inherit;
}
.y2uxss3 {
  width: var(--_18w76bwg);
  height: var(--_18w76bwg);
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,gBAAgB;EAChB,SAAS;EACT,aAAa;EACb,YAAY;EACZ,iBAAiB;EACjB,qBAAqB;EACrB,+BAA+B;EAC/B,8BAA8B;EAC9B,4BAA4B;EAC5B,+BAA+B;EAC/B,mCAAmC;AACrC;AACA;EACE;;SAEO;EACP,aAAa;EACb,uBAAuB;EACvB,wBAAwB;EACxB,gBAAgB;EAChB,+BAA+B;EAC/B,uCAAuC;AACzC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,mCAAmC;EACnC,+BAA+B;AACjC;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,uBAAuB;EACvB,wBAAwB;AAC1B","sourcesContent":[".y2uxss0 {\n  display: grid;\n  appearance: none;\n  margin: 0;\n  font: inherit;\n  color: white;\n  border: 1px solid;\n  place-content: center;\n  border-radius: var(--_18w76bwa);\n  border-width: var(--_18w76bwa);\n  margin-top: var(--_18w76bwb);\n  border-color: var(--_18w76bw34);\n  background-color: var(--_18w76bw24);\n}\n.y2uxss0:before {\n  content: url(\n          \"data:image/svg+xml,<svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'><path d='M8.15147 20.5971L0.351472 12.7971C-0.117137 12.3285 -0.117137 11.5687 0.351472 11.1L2.04849 9.40294C2.5171 8.93428 3.27694 8.93428 3.74555 9.40294L9 14.6573L20.2545 3.40294C20.7231 2.93433 21.4829 2.93433 21.9515 3.40294L23.6485 5.1C24.1171 5.56861 24.1171 6.32841 23.6485 6.79706L9.84854 20.5971C9.37988 21.0657 8.62008 21.0657 8.15147 20.5971Z' fill='white'/></svg>\"\n        );\n  display: none;\n  width: var(--_18w76bwe);\n  height: var(--_18w76bwe);\n  border-radius: 0;\n  margin-bottom: var(--_18w76bwb);\n  transition: 100ms transform ease-in-out;\n}\n.y2uxss0:focus:not(:checked) {\n  border-color: var(--_18w76bw2e);\n}\n.y2uxss0:checked {\n  background-color: var(--_18w76bw30);\n  border-color: var(--_18w76bw30);\n}\n.y2uxss0:checked:before {\n  display: block;\n}\n.y2uxss2:checked {\n  background-color: inherit;\n  border-color: inherit;\n}\n.y2uxss3 {\n  width: var(--_18w76bwg);\n  height: var(--_18w76bwg);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
